/* Canvas stepper — Personalize -> Size -> Frame -> Extras (add to cart).
   Drives Teeinblue's (hidden) product/color/size radios and quantity so its variant,
   printarea, AI preview and print quantity always match the customer's choices.
   Also: digital-file add-on (separate Shopify product) and optional digital-only variant. */
(function () {
  var root = document.querySelector('[data-canvas-stepper]');
  if (!root) return;

  var data = JSON.parse(root.querySelector('[data-cs-data]').textContent);
  var STEPS = 4;
  var DISC = (data.extraDiscountPct || 0) / 100;
  var MAX_EXTRA = data.maxExtra || 3;
  var ADDON = data.addon || null;
  // Matching Christmas cards: the campaign's card product (10-pack), same customization as the canvas.
  var CARD_PACK = data.variants.find(function (v) { return /card/i.test(v.o1) && /(^|\D)10\s*(pcs|cards)/i.test(v.o3); }) || null;
  // Matching mug: the campaign's 11oz mug product (Teeinblue makes its own mug customization on add).
  var MUG = data.variants.find(function (v) { return /mug/i.test(v.o1); }) || null;
  // Free digital file: every canvas gets "Digital file: Yes" (Teeinblue's Download block sends it), no paid add-on.
  var FREE_DIGITAL = !!data.digitalFree;
  function wantDigital() { return (FREE_DIGITAL || state.addon) && !digital(); }

  // Sizes in display order; aliases cover both the cm values and inch values (after renaming).
  var SIZES = [
    { key: 's1', label: '8″ × 10″', aliases: ['20x25', '8x10'] },
    { key: 's2', label: '12″ × 18″', aliases: ['30x45', '12x18'] },
    { key: 's3', label: '16″ × 24″', aliases: ['40x60', '16x24'] },
    { key: 's4', label: '24″ × 36″', aliases: ['60x90', '24x36'] }
  ];
  // Room scene on the size cards (assets/cs-room.jpg, 1200x900): 84" sofa = 660px -> 7.857 px per inch.
  // Each canvas hangs centred above the sofa, bottom edge 12" above its back (y = 376px).
  var ROOM_PX_IN = 660 / 84;
  var ROOM_IN = { s1: [8, 10], s2: [12, 18], s3: [16, 24], s4: [24, 36] };
  var FRAME_LABELS = { none: 'Unframed', black: 'Black', 'dark-wood': 'Dark Wood', 'natural-wood': 'Natural Wood' };

  function norm(s) {
    // Printify sizes read like `12″ x 18″ (Vertical) / 1.25"` — keep only the dimensions.
    s = String(s || '').split(/[(\/]/)[0];
    return s.toLowerCase().replace(/[″"”']|inch(es)?|in\b|cm/g, '').replace(/[×*]/g, 'x').replace(/\s+/g, '');
  }
  // Frame color -> stepper key. Gelato says dark-wood / natural-wood; Printify says Espresso / Natural.
  var FRAME_ALIASES = { espresso: 'dark-wood', natural: 'natural-wood', default: 'none' };
  function frameKey(s) {
    var k = String(s || '').toLowerCase().trim().replace(/\s+/g, '-');
    return FRAME_ALIASES[k] || k;
  }
  function sizeKeyOf(value) {
    var n = norm(value);
    for (var i = 0; i < SIZES.length; i++) if (SIZES[i].aliases.indexOf(n) !== -1) return SIZES[i].key;
    return null;
  }
  function isDigitalV(v) { return /digital/i.test(v.o1); }
  function isCardV(v) { return /card|mug/i.test(v.o1); }
  function isFramed(v) { return /framed/i.test(v.o1); }
  function frameKeyOf(v) { return isFramed(v) ? frameKey(v.o2) : 'none'; }
  var digitalVariant = data.variants.find(isDigitalV) || null;
  function findVariant(size, frame) {
    if (size === 'digital') return digitalVariant;
    return data.variants.find(function (v) { return !isDigitalV(v) && !isCardV(v) && sizeKeyOf(v.o3) === size && frameKeyOf(v) === frame; });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function sizeLabel(k) { return k === 'digital' ? 'Digital file' : ((SIZES.find(function (s) { return s.key === k; }) || {}).label || ''); }

  // Initial state from the selected variant.
  var initial = data.variants.find(function (v) { return v.id === data.selected && !isDigitalV(v); }) ||
    data.variants.find(function (v) { return !isDigitalV(v); }) || data.variants[0];
  var state = { step: 1, size: sizeKeyOf(initial.o3) || 's1', frame: frameKeyOf(initial), extra: 0, addon: false, cards: false, mug: false };
  var digital = function () { return state.size === 'digital'; };

  var $ = function (sel) { return root.querySelector(sel); };

  // Build size cards (+ digital-only card when the product has a digital variant).
  var sizesEl = $('[data-cs-sizes]');
  SIZES.concat(digitalVariant ? [{ key: 'digital', label: 'Digital only' }] : []).forEach(function (s) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cs-card cs-card--size';
    b.setAttribute('data-cs-size', s.key);
    var room = sizesEl.getAttribute('data-cs-room');
    var dims = ROOM_IN[s.key];
    b.innerHTML = (room && dims ? '<span class="cs-room"><img class="cs-room__bg" src="' + room + '" alt="" loading="lazy">' +
        '<span class="cs-room__art" data-cs-room-art style="width:' + (dims[0] * ROOM_PX_IN / 1200 * 100).toFixed(2) + '%;height:' +
        (dims[1] * ROOM_PX_IN / 900 * 100).toFixed(2) + '%"></span></span>' : '') +
      '<span class="cs-card__label">' + s.label + '</span><span class="cs-card__delta" data-cs-delta></span>';
    sizesEl.appendChild(b);
  });
  // Build extra-print options.
  var extrasEl = $('[data-cs-extras]');
  for (var n = 0; n <= MAX_EXTRA; n++) {
    var eb = document.createElement('button');
    eb.type = 'button';
    eb.className = 'cs-card cs-card--extra';
    eb.setAttribute('data-cs-extra', n);
    eb.innerHTML = '<span class="cs-card__label">' + (n === 0 ? 'No extra prints' : '+' + n + ' extra print' + (n > 1 ? 's' : '')) +
      '</span><span class="cs-card__delta" data-cs-delta></span>';
    extrasEl.appendChild(eb);
  }
  if (!ADDON) $('[data-cs-addon-block]').hidden = true;

  function extraUnit(v) { return Math.round(v.price * (1 - DISC)); }

  // "Continue to extras" lives directly under Teeinblue's form on the Personalize step,
  // so customers don't scroll back up to the stepper's Next button.
  var continueBtn = null, continueMsg = null;
  function mountContinue() {
    var anchor = document.querySelector('#teeFormActions');
    if (!anchor || continueBtn) return !!continueBtn;
    var wrap = document.createElement('div');
    wrap.className = 'cs cs-continue';
    var hasName = !!document.querySelector('.tee-field--text input');
    var msg = hasName ? 'Please upload your dog\u2019s photo and enter their name first.' : 'Please upload your dog\u2019s photo first.';
    var sub = document.querySelector('[data-cs-upload-sub]');
    if (sub && hasName) sub.textContent = 'Add a clear, close-up photo of your dog and their name, then preview their portrait.';
    wrap.innerHTML = '<p class="cs-continue__msg" hidden>' + msg + '</p>' +
      '<button type="button" class="cs-next cs-continue__btn">Continue to size \u2192</button>';
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    continueBtn = wrap;
    continueMsg = wrap.querySelector('.cs-continue__msg');
    wrap.querySelector('button').addEventListener('click', function () { go(2); });
    render();
    return true;
  }

  function render() {
    root.setAttribute('data-step', state.step);
    document.body.classList.add('cs-on');
    document.body.classList.toggle('cs-step-1', state.step === 1);
    document.body.classList.toggle('cs-step-4', state.step === 4);
    if (continueBtn) continueBtn.hidden = state.step !== 1;
    if (continueMsg && state.step !== 1) continueMsg.hidden = true;

    root.querySelectorAll('[data-cs-go]').forEach(function (t) {
      var n = +t.getAttribute('data-cs-go');
      t.classList.toggle('is-current', n === state.step);
      t.classList.toggle('is-done', n < state.step);
      t.disabled = n === 3 && digital();
    });
    $('[data-cs-stepcount]').textContent = 'Step ' + state.step + ' of ' + STEPS;
    var togo = STEPS - state.step;
    $('[data-cs-togo]').textContent = togo ? togo + (togo === 1 ? ' step' : ' steps') + ' to go' : 'Last step';
    root.querySelectorAll('[data-cs-panel]').forEach(function (p) { p.hidden = +p.getAttribute('data-cs-panel') !== state.step; });
    var back = $('[data-cs-back]'); back.hidden = false; back.style.visibility = state.step === 1 ? 'hidden' : 'visible';

    // Size cards: price difference vs the smallest size, for the chosen frame.
    var frameForSizes = digital() ? 'none' : state.frame;
    var base = findVariant('s1', frameForSizes);
    root.querySelectorAll('[data-cs-size]').forEach(function (b) {
      var k = b.getAttribute('data-cs-size');
      var v = findVariant(k, frameForSizes);
      b.disabled = !v || !v.available;
      b.classList.toggle('is-selected', k === state.size);
      var d = v && base ? v.price - base.price : 0;
      var dl = b.querySelector('[data-cs-delta]');
      dl.textContent = !v ? 'Unavailable' : (k === 'digital' || d <= 0) ? money(v.price) : '+' + money(d);
      dl.classList.toggle('is-base', !!v && k !== 'digital' && d <= 0);
      var ra = b.querySelector('[data-cs-room-art]');
      if (ra) ra.setAttribute('data-frame', frameForSizes);
    });
    $('[data-cs-size-label]').textContent = sizeLabel(state.size);

    // Frame cards: price difference vs unframed, for the chosen size.
    var unframed = findVariant(state.size, 'none');
    root.querySelectorAll('[data-cs-frame]').forEach(function (b) {
      var f = b.getAttribute('data-cs-frame');
      var v = findVariant(state.size, f);
      b.disabled = !v || !v.available;
      b.classList.toggle('is-selected', f === state.frame);
      var d = v && unframed ? v.price - unframed.price : 0;
      b.querySelector('[data-cs-delta]').textContent = d > 0 ? '+' + money(d) : '';
    });
    $('[data-cs-frame-label]').textContent = FRAME_LABELS[state.frame] || '';

    var sel = findVariant(state.size, state.frame);

    // Extras panel.
    $('[data-cs-extra-block]').hidden = digital();
    $('[data-cs-addon-block]').hidden = digital() || !ADDON;
    $('[data-cs-digital-note]').hidden = !digital();
    if (digital()) { state.extra = 0; state.addon = false; }
    root.querySelectorAll('[data-cs-extra]').forEach(function (b) {
      var n = +b.getAttribute('data-cs-extra');
      b.classList.toggle('is-selected', n === state.extra);
      b.querySelector('[data-cs-delta]').textContent = n && sel ? '+' + money(extraUnit(sel) * n) : '';
    });
    var addonBox = $('[data-cs-addon]');
    if (addonBox) addonBox.checked = state.addon;
    var cardsBlock = $('[data-cs-cards-block]');
    if (cardsBlock) {
      cardsBlock.hidden = !CARD_PACK || digital();
      var cb = $('[data-cs-cards]'); if (cb) cb.checked = state.cards;
      if (CARD_PACK) $('[data-cs-cards-price]').textContent = '+' + money(CARD_PACK.price);
    }
    var mugBlock = $('[data-cs-mug-block]');
    if (mugBlock) {
      mugBlock.hidden = !MUG || digital();
      var mb = $('[data-cs-mug]'); if (mb) mb.checked = state.mug;
      if (MUG) $('[data-cs-mug-price]').textContent = '+' + money(MUG.price);
    }
    if (ADDON) $('[data-cs-addon-price]').textContent = '+' + money(ADDON.price);

    // Summary.
    if (sel) {
      var item = digital() ? 'Digital file' : sizeLabel(state.size) + ' · ' + (state.frame === 'none' ? 'Canvas' : FRAME_LABELS[state.frame] + ' frame');
      $('[data-cs-summary-item]').textContent = item;
      $('[data-cs-price]').textContent = money(sel.price);
      var extraCost = state.extra * extraUnit(sel);
      var addonCost = state.addon && ADDON ? ADDON.price : 0;
      var cardsCost = state.cards && CARD_PACK && !digital() ? CARD_PACK.price : 0;
      var cr = $('[data-cs-cards-row]'); if (cr) { cr.hidden = !cardsCost; $('[data-cs-cards-row-price]').textContent = money(cardsCost); }
      var mugCost = state.mug && MUG && !digital() ? MUG.price : 0;
      var mr = $('[data-cs-mug-row]'); if (mr) { mr.hidden = !mugCost; $('[data-cs-mug-row-price]').textContent = money(mugCost); }
      $('[data-cs-extra-row]').hidden = !state.extra;
      $('[data-cs-extra-item]').textContent = state.extra ? '+' + state.extra + ' extra print' + (state.extra > 1 ? 's' : '') + ' (' + Math.round(DISC * 100) + '% off)' : '';
      $('[data-cs-extra-price]').textContent = money(extraCost);
      $('[data-cs-addon-row]').hidden = !(addonCost || (FREE_DIGITAL && !digital()));
      $('[data-cs-addon-row-price]').textContent = FREE_DIGITAL ? 'FREE' : money(addonCost);
      var total = sel.price + extraCost + addonCost + cardsCost + mugCost;
      var unitCompare = sel.compare > sel.price ? sel.compare : sel.price;
      var compare = unitCompare * (1 + state.extra) + addonCost + cardsCost + mugCost;
      $('[data-cs-total]').textContent = money(total);
      $('[data-cs-compare]').textContent = compare > total ? money(compare) : '';
      var save = $('[data-cs-save]');
      save.hidden = !(compare > total);
      save.textContent = compare > total ? 'Saving ' + money(compare - total) : '';
    }
  }

  // ---- Teeinblue bridge -------------------------------------------------------------
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  async function waitFor(fn, timeout) {
    var end = Date.now() + (timeout || 8000);
    while (Date.now() < end) { var r = fn(); if (r) return r; await sleep(120); }
    return null;
  }
  function radios(scope) { return Array.prototype.slice.call(document.querySelectorAll(scope + ' input[type="radio"]')); }
  function labelText(input) {
    var l = document.querySelector('label[for="' + input.id + '"]');
    return (l ? l.textContent : input.value || '').trim();
  }
  // Click the visible LABEL (what a shopper clicks), not the hidden input: Teeinblue's
  // available-product buttons ignore programmatic clicks on the bare input.
  function pick(input) {
    if (!input) return false;
    var box = input.closest('.tee-radio');
    // Teeinblue's own 'active' class is the truth; a stale native `checked` (seen after switching
    // products, e.g. Christmas Cards -> Canvas) must not stop us clicking.
    if (box ? box.classList.contains('active') : input.checked) return true;
    var label = document.querySelector('label[for="' + input.id + '"]');
    (label || box || input).click();
    return true;
  }
  function dbg(msg) {  // QA trace, only with ?cs_debug=1
    if (!/cs_debug=1/.test(location.search)) return;
    root.setAttribute('data-cs-debug', (root.getAttribute('data-cs-debug') || '') + ' | ' + msg);
    var box = document.getElementById('cs-debug-box');
    if (!box) {
      box = document.createElement('div'); box.id = 'cs-debug-box';
      box.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;max-width:420px;max-height:45vh;overflow:auto;background:#111;color:#7CFC00;font:12px/1.4 monospace;padding:8px 10px;border-radius:6px;white-space:pre-wrap;opacity:.92';
      document.body.appendChild(box);
    }
    box.textContent += new Date().toTimeString().slice(0, 8) + '  ' + msg + '\n';
    box.scrollTop = box.scrollHeight;
  }
  function setTeeQuantity(q) {
    var inp = document.querySelector('.tee-quantity-input');
    if (!inp || String(inp.value) === String(q)) return;
    inp.value = q;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Teeinblue's currently-active product / frame / size, read from its (hidden) radios.
  function teeActive() {
    function act(scope) {
      var el = document.querySelector(scope + ' .tee-radio.active input') ||
               radios(scope).find(function (i) { return i.checked; });
      return el || null;
    }
    var prod = act('.tee-available-products');
    var color = act('.tee-option--color');
    var size = act('.tee-option--size');
    return {
      prod: prod ? labelText(prod).toLowerCase() : '',
      frame: color ? frameKey(color.value) : '',
      size: size ? sizeKeyOf(size.value) : null
    };
  }
  function teeMatches() {
    var a = teeActive();
    if (digital()) return a.prod.indexOf('digital') !== -1;
    var framed = state.frame !== 'none';
    if (framed ? a.prod.indexOf('framed') === -1 : (a.prod.indexOf('framed') !== -1 || a.prod.indexOf('digital') !== -1 || a.prod.indexOf('card') !== -1 || a.prod.indexOf('mug') !== -1)) return false;
    if (framed && a.frame !== state.frame) return false;
    return a.size === state.size;
  }

  // Each sync gets a generation number; an older sync stops as soon as a newer one starts,
  // so a slow "size" sync can never overwrite a later "frame" choice (the Canvas-instead-of-Framed bug).
  var syncGen = 0;
  var syncing = null;
  function syncTeeinblue() {
    var gen = ++syncGen;
    var target = { size: state.size, frame: state.frame, qty: 1 + state.extra };
    var stale = function () { return gen !== syncGen; };
    syncing = (async function () {
      var kind = target.size === 'digital' ? 'digital' : target.frame !== 'none' ? 'framed' : 'canvas';
      // 1. Product: Canvas / Framed Canvas / Digital.
      var prod = await waitFor(function () {
        return radios('.tee-available-products').find(function (i) {
          var t = labelText(i).toLowerCase();
          if (kind === 'digital') return t.indexOf('digital') !== -1;
          if (kind === 'framed') return t.indexOf('framed') !== -1;
          return t.indexOf('framed') === -1 && t.indexOf('digital') === -1 && t.indexOf('card') === -1 && t.indexOf('mug') === -1;
        });
      }, 15000);
      if (!prod || stale()) { dbg('no prod/stale'); return; }
      pick(prod); dbg('prod->' + labelText(prod));
      if (kind !== 'digital') {
        // 2. Frame color (framed only). Teeinblue re-renders options after a product switch.
        if (kind === 'framed') {
          var color = await waitFor(function () {
            return radios('.tee-option--color').find(function (i) { return frameKey(i.value) === target.frame; });
          });
          if (stale()) return;
          pick(color); dbg('color->' + (color && color.value));
        }
        // 3. Size.
        var size = await waitFor(function () {
          return radios('.tee-option--size').find(function (i) { return sizeKeyOf(i.value) === target.size; });
        });
        if (stale()) return;
        pick(size); dbg('size->' + (size && size.value));
      }
      // 4. Print quantity (1 + extra prints).
      await waitFor(function () { return document.querySelector('.tee-quantity-input'); }, 4000);
      if (stale()) return;
      setTeeQuantity(target.qty);
      setTimeout(showChosenMockup, 400);
    })();
    return syncing;
  }
  // ---- Gallery follows the chosen frame ---------------------------------------------------
  // Teeinblue's gallery holds one slide per campaign mockup (e.g. black / natural / dark wood)
  // but doesn't switch slides when the variant changes. Look up the chosen variant's mockup in
  // the campaign data and click that thumbnail.
  var campaignData = null;
  function loadCampaign() {
    if (campaignData) return Promise.resolve(campaignData);
    // Use the same campaign version Teeinblue loaded (the unversioned URL can be a stale cached copy).
    var shop = (window.Shopify && window.Shopify.shop) || location.hostname;
    var ver = (window.teeinblueCampaign && window.teeinblueCampaign.version) || Date.now();
    return fetch('https://api.teeinblue.com/api/merchant/campaigns/' + data.productId + '.json?shop=' + encodeURIComponent(shop) + '&v=' + ver)
      .then(function (r) { return r.json(); })
      .then(function (d) { campaignData = d; return d; })
      .catch(function () { return null; });
  }
  async function showChosenMockup() {
    if (typeof hideOverlay === 'function') hideOverlay();
    var sel = findVariant(state.size, state.frame);
    var d = await loadCampaign();
    if (!sel || !d) return;
    var iv = (d.instance_variants || []).find(function (x) { return String(x.platform_linked_id) === String(sel.id); });
    if (!iv) return;
    var cp = (d.campaign_products || []).find(function (p) {
      return (p.campaign_variants || []).some(function (v) { return v.variant_id === iv.variant_id; });
    });
    if (!cp) return;
    var cv = cp.campaign_variants.find(function (v) { return v.variant_id === iv.variant_id; });
    var mockups = (cp.campaign_mockups || []).slice().sort(function (a, b) { return (a.position || 0) - (b.position || 0); });
    var idx = mockups.findIndex(function (m) { return m.id === cv.campaign_mockup_id; });
    if (idx < 0) return;
    // Teeinblue rebuilds the gallery after a product switch (e.g. Unframed -> Framed) and resets
    // it to slide 1, sometimes after we've already clicked — so keep checking for a few seconds
    // and re-select until the chosen mockup's thumbnail is the active one.
    var key = (mockups[idx].preview_thumbnail || '').split('/').pop();
    var gen = ++galleryGen, end = Date.now() + 8000;
    while (Date.now() < end && gen === galleryGen) {
      var thumbs = document.querySelectorAll('#tee-gallery .tee-mockup-thumbnail');
      if (thumbs.length === mockups.length) {
        // Match by image (positions can tie); fall back to position order.
        var hit = (key && Array.prototype.find.call(thumbs, function (t) { return (t.getAttribute('src') || '').indexOf(key) >= 0; })) || thumbs[idx];
        var box = hit.closest('.tee-thumbnail');
        if (!(box && box.classList.contains('tee-thumbnail--active'))) hit.click();
      }
      await sleep(300);
    }
  }
  var galleryGen = 0;

  // Sync, then confirm Teeinblue really holds the chosen variant (retrying a couple of times).
  async function ensureSynced() {
    for (var attempt = 0; attempt < 3; attempt++) {
      await syncTeeinblue();
      await sleep(250);
      var a = teeActive(); dbg('verify ' + JSON.stringify(a) + ' ok=' + teeMatches());
      if (teeMatches()) return true;
    }
    return teeMatches();
  }

  // ---- Live frame thumbnails ---------------------------------------------------------
  // Teeinblue renders the customer's design (AI portrait + name) once, as a hidden
  // <svg id="tee-artwork-…">, and its gallery places it with <use>. The frame cards do the
  // same over a frame background, so each card shows the customer's own portrait in that
  // frame and updates live. Static thumbnails stay as a fallback until it exists.
  // The customer's portrait artwork. Campaigns with a card product also render the card's
  // inside-greeting artwork (landscape, no photo) — always pick the portrait-shaped one.
  function teeArt() {
    var all = Array.prototype.slice.call(document.querySelectorAll('svg[id^="tee-artwork-"]'));
    return all.find(function (s) {
      var vb = (s.getAttribute('viewBox') || '').split(/\s+/);
      return +vb[3] > +vb[2];
    }) || all[0] || null;
  }
  function liveUse(art, w, h) {
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" preserveAspectRatio="xMidYMid slice" aria-hidden="true">' +
      '<use href="#' + art.id + '" width="' + w + '" height="' + h + '"></use></svg>';
  }
  // Live portrait for the previews: Teeinblue's hidden artwork SVG when it's on the page,
  // otherwise the painted image in the upload box (Teeinblue only mounts the SVG on demand).
  function livePhotoSrc() {
    var el = document.querySelector('.tee-field--photo .tee-photo-image, .tee-field--photo .tee-photo-head img');
    if (!el) return '';
    var src = el.currentSrc || el.src || '';
    if (!src) { var m = /url\(["']?([^"')]+)/.exec(getComputedStyle(el).backgroundImage || ''); src = m ? m[1] : ''; }
    return src;
  }
  function liveArt() {
    var art = teeArt();
    if (art) {
      var vb = (art.getAttribute('viewBox') || '').split(/\s+/);
      var w = vb[2] || 741, h = vb[3] || 1102;
      return { key: 'svg:' + art.id, html: liveUse(art, w, h) };
    }
    var src = livePhotoSrc();
    return src ? { key: 'img:' + src, html: '<img src="' + src + '" alt="" style="display:block;width:100%;height:100%;object-fit:cover">' } : null;
  }
  function fillLive(el, a) {
    if (el.getAttribute('data-live-key') === a.key) return;
    el.setAttribute('data-live-key', a.key);
    el.innerHTML = a.html;
  }
  function mountLiveExtras() {
    var a = liveArt();
    if (!a) return false;
    root.querySelectorAll('[data-cs-room-art], [data-cs-card-art], [data-cs-mug-art], [data-cs-portrait-art]').forEach(function (el) { fillLive(el, a); });
    return true;
  }
  // Show the portrait in step 1 as soon as a photo is in (no need to click Preview).
  function syncPortrait() {
    var box = root.querySelector('[data-cs-portrait]');
    if (!box) return;
    var photo = document.querySelector('.tee-field--photo .tee-photo-image, .tee-field--photo .tee-photo-head img');
    box.hidden = !photo;
  }
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cs-portrait-more]')) return;
    var pv = document.querySelector('.tee-btn--preview');
    if (pv) pv.click();
  });

  // ---- "Regenerate portrait": re-run Teeinblue's AI on the same photo ------------------
  // Remembers the last photo the customer picked and feeds it back into Teeinblue's file
  // input, which re-uploads it and repaints the portrait (counts toward Teeinblue's upload limit).
  (function () {
    var lastFile = null;
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.tee-field--photo input[type="file"]') && t.files && t.files[0] && !t.__csRegen) lastFile = t.files[0];
      if (t) t.__csRegen = false;
    }, true);
    function ensureBtn() {
      var field = document.querySelector('.tee-field--photo');
      if (!field) return;
      var hasPhoto = !!field.querySelector('.tee-photo-image, .tee-photo-head img');
      var actions = field.querySelector('.tee-photo-action');
      var btn = field.querySelector('.cs-regen');
      if (!lastFile || !hasPhoto || !actions) { if (btn) btn.remove(); return; }
      if (btn) return;
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-regen';
      btn.textContent = '↻ Regenerate portrait';
      btn.title = 'Paint a new version from the same photo';
      btn.addEventListener('click', function () {
        var input = field.querySelector('.tee-photo-input input[type="file"], input[type="file"]');
        if (!input || !lastFile || typeof DataTransfer === 'undefined') return;
        var dt = new DataTransfer();
        dt.items.add(lastFile);
        input.files = dt.files;
        input.__csRegen = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        btn.disabled = true; btn.textContent = 'Painting a new version…';
        setTimeout(function () { btn.disabled = false; btn.textContent = '↻ Regenerate portrait'; }, 15000);
      });
      actions.appendChild(btn);
    }
    setInterval(ensureBtn, 700);
  })();

  // Card preview pop-up (front = live portrait, inside = fixed greeting image)
  root.addEventListener('click', function (e) {
    ['cards', 'mug'].forEach(function (k) {
      var m = root.querySelector('[data-cs-' + k + '-modal]');
      if (!m) return;
      if (e.target.closest('[data-cs-' + k + '-open]')) { e.preventDefault(); mountLiveExtras(); m.hidden = false; return; }
      if (e.target.closest('[data-cs-' + k + '-close]') || e.target === m) m.hidden = true;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    root.querySelectorAll('[data-cs-cards-modal], [data-cs-mug-modal]').forEach(function (m) { m.hidden = true; });
  });
  // Inline portrait panel removed 2026-10-02 (Teeinblue's upload thumbnail already shows the AI result).

  // ---- Auto-open Teeinblue's preview once the uploaded photo is painted --------------
  // Opens once per photo, after the upload thumbnail has stopped changing for 1.5s and no
  // loader is showing (so the AI result, not the raw photo, is what they see). Designs with a
  // name field wait for the name too (then open when the name box loses focus).
  var autoPv = { seen: null, since: 0, shown: null, armed: false };
  function photoKey() {
    var el = document.querySelector('.tee-field--photo .tee-photo-image, .tee-field--photo .tee-photo-head img');
    if (!el) return null;
    return el.currentSrc || el.src || getComputedStyle(el).backgroundImage || 'photo';
  }
  function photoBusy() {
    var f = document.querySelector('.tee-field--photo');
    if (!f) return false;
    return Array.prototype.some.call(f.querySelectorAll('[class*="loading"],[class*="spinner"],[class*="progress"]'),
      function (n) { return n.offsetParent !== null; });
  }
  function openPreviewIfReady() {
    var key = photoKey();
    if (!autoPv.armed || !key || key === autoPv.shown || state.step !== 1) return;
    if (Date.now() - autoPv.since < 1500 || photoBusy() || !formReady()) return;
    var pv = document.querySelector('.tee-btn--preview');
    if (!pv || pv.disabled) return;
    autoPv.shown = key;
    pv.click();
  }
  setInterval(function () {
    var key = photoKey();
    if (key !== autoPv.seen) { autoPv.seen = key; autoPv.since = Date.now(); }
    var nameInput = document.querySelector('.tee-field--text input');
    if (!nameInput || document.activeElement !== nameInput) openPreviewIfReady();
  }, 500);
  document.addEventListener('focusout', function (e) {
    if (e.target.matches && e.target.matches('.tee-field--text input')) setTimeout(openPreviewIfReady, 200);
  });
  // Don't pop up on load for a photo Teeinblue restored from an earlier visit.
  setTimeout(function () { autoPv.shown = photoKey(); autoPv.armed = true; }, 4000);

  // Picking a frame switches the theme's native gallery to that frame's photo
  // (clicks the matching visible thumbnail; the theme does the rest).
  function showFrameMedia(frame) {
    var id = (data.frameMedia || {})[frame];
    if (!id) return;
    document.querySelectorAll('[data-thumbnail-id="' + id + '"]').forEach(function (t) {
      if (t.offsetParent !== null) t.click();
    });
  }

  function mountLiveFrames() {
    var a = liveArt();
    if (!a) return false;
    root.querySelectorAll('[data-cs-frame]').forEach(function (b) {
      var live = b.querySelector('.cs-live');
      if (!live) {
        var img = b.querySelector('img:not(.cs-swatch)');
        var bg = b.getAttribute('data-cs-live-bg');
        if (!img || !bg) return;
        live = document.createElement('span');
        live.className = 'cs-live';
        live.innerHTML = '<img class="cs-live__bg" src="' + bg + '" alt="" width="240" height="300"><span class="cs-live__art"></span>';
        img.replaceWith(live);
      }
      fillLive(live.querySelector('.cs-live__art'), a);
    });
    return true;
  }


  // ---- Teeinblue "Digital file" add-on field (addon-charge layer, No / Yes) -----------
  // When the artwork has this field, Teeinblue adds + links the Digital Portrait File itself
  // and its Digital Download block serves the per-order file. The stepper just selects Yes/No
  // and hides Teeinblue's own copy of the field. Falls back to adding the product directly.
  function teeDigitalField() {
    var fields = document.querySelectorAll('.tee-field');
    for (var i = 0; i < fields.length; i++) {
      var h = fields[i].querySelector('.tee-field__heading');
      if (h && /digital file/i.test(h.textContent) && fields[i].querySelector('input[type="radio"]')) return fields[i];
    }
    return null;
  }
  function teeDigitalRadio(want) {
    var f = teeDigitalField();
    if (!f) return null;
    return Array.prototype.slice.call(f.querySelectorAll('input[type="radio"]')).find(function (i) {
      return labelText(i).toLowerCase() === (want ? 'yes' : 'no');
    }) || null;
  }
  function syncDigitalAddon() {
    var f = teeDigitalField();
    if (!f) return false;
    f.classList.add('cs-tee-hidden');
    pick(teeDigitalRadio(wantDigital()));
    return true;
  }
  function digitalAddonMatches() {
    var r = teeDigitalRadio(wantDigital());
    if (!r) return true;
    var box = r.closest('.tee-radio');
    return r.checked || (box && box.classList.contains('active'));
  }

  // ---- Digital-file add-on: added right before Teeinblue's own add-to-cart ---------
  // The theme refreshes its cart drawer on an internal event bus we can't reach, so the
  // add-on goes into the cart FIRST; Teeinblue's add then opens the drawer showing both.
  function petName() {
    var inp = document.querySelector('.tee-field--text input');
    return inp ? inp.value.trim() : '';
  }
  function formReady() {
    var photo = document.querySelector('.tee-field--photo .tee-photo-image, .tee-field--photo .tee-photo-head img');
    // Designs without a name field (e.g. The Patriot) only need the photo.
    var hasName = !!document.querySelector('.tee-field--text input');
    return !!photo && (!hasName || !!petName());
  }
  async function addAddonOnce() {
    var label = (petName() || 'Pet') + ' — ' + (document.title.split(/[–|]/)[0] || '').trim();
    var cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
    var dup = cart.items.some(function (it) {
      return it.variant_id === ADDON.variant && it.properties && it.properties['Portrait'] === label;
    });
    if (dup) return;
    await fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: ADDON.variant, quantity: 1, properties: { 'Portrait': label } }] })
    });
  }
  // Every add-to-cart goes through here first: re-sync + verify the variant, set the print
  // quantity, add the digital file if chosen, then let Teeinblue's own add-to-cart run.
  var atcMsg = null;
  function showAtcMsg(text) {
    var btn = document.querySelector('.tee-btn--atc');
    if (!btn) return;
    if (!atcMsg) {
      atcMsg = document.createElement('p');
      atcMsg.className = 'cs-continue__msg';
      btn.parentNode.insertBefore(atcMsg, btn);
    }
    atcMsg.textContent = text;
    atcMsg.hidden = !text;
  }
  function nfetch() { return window.__nativeFetch || _fetch; }
  // Counts successful /cart/add responses (set by the fetch/XHR hooks below), so teeAdd() knows
  // the moment Teeinblue's add finished instead of polling the cart.
  var cartAdds = 0;
  function noteCartAdd() { cartAdds++; }
  async function cartCount() {
    try { var r = await nfetch().call(window, '/cart.js', { credentials: 'same-origin' }); return (await r.json()).item_count; }
    catch (e) { return null; }
  }
  // Teeinblue's live ATC button (it re-renders after each add, so never reuse an old one).
  function teeAtcBtn() {
    return Array.prototype.find.call(document.querySelectorAll('.tee-btn--atc'), function (b) {
      return !b.closest('.tee-dialog') && b.isConnected;
    }) || null;
  }
  // Click Teeinblue's ATC ourselves and wait until the cart actually grew.
  async function teeAdd() {
    var btn = await waitFor(function () {
      var b = teeAtcBtn();
      return b && !b.disabled && !/loading|disabled/i.test(b.className) ? b : null;
    }, 15000);
    dbg('teeAdd btn=' + !!btn);
    if (!btn) return false;
    var addsBefore = cartAdds;
    var before = await cartCount();
    dbg('clicking ATC, cart count before=' + before);
    btn.__csPass = true;
    btn.click();
    var t0 = Date.now(), end = t0 + 25000, lastPoll = t0;
    while (Date.now() < end) {
      await sleep(80);
      if (cartAdds > addsBefore) { dbg('add confirmed in ' + (Date.now() - t0) + 'ms'); return true; }
      // Fallback (another app re-wrapped fetch): check the cart itself every 1.5s.
      if (Date.now() - lastPoll > 1500) {
        lastPoll = Date.now();
        var n = await cartCount();
        if (n !== null && before !== null && n > before) { dbg('cart count now=' + n); return true; }
      }
    }
    return false;
  }
  // Switch Teeinblue's hidden form to the Christmas Cards product, 10-pack.
  async function selectCardsInTee() {
    var prod = await waitFor(function () {
      return radios('.tee-available-products').find(function (i) { return /card/i.test(labelText(i)); });
    }, 8000);
    dbg('cards product radio=' + (prod ? labelText(prod) : 'NOT FOUND'));
    if (!prod) return false;
    pick(prod);
    var size = await waitFor(function () {
      return radios('.tee-option--size').find(function (i) { return /(^|\D)10\s*(pcs|cards)/i.test(i.value + ' ' + labelText(i)); });
    }, 8000);
    dbg('cards size radio=' + (size ? size.value : 'NOT FOUND'));
    if (!size) return false;
    pick(size);
    await sleep(150);
    setTeeQuantity(1);
    // Cards don't come with the digital file: set Teeinblue's "Digital file" to No for this add
    // (the canvas add right after switches it back to Yes via syncDigitalAddon()).
    var no = teeDigitalRadio(false);
    if (no) {
      pick(no);
      await waitFor(function () { var b = no.closest('.tee-radio'); return b ? b.classList.contains('active') : no.checked; }, 3000);
      dbg('cards digital file -> No');
    }
    return true;
  }
  // Switch Teeinblue's hidden form to the Mug product (single 11oz variant).
  async function selectMugInTee() {
    var prod = await waitFor(function () {
      return radios('.tee-available-products').find(function (i) { return /mug/i.test(labelText(i)); });
    }, 8000);
    dbg('mug product radio=' + (prod ? labelText(prod) : 'NOT FOUND'));
    if (!prod) return false;
    pick(prod);
    var ok = await waitFor(function () { return /mug/i.test(teeActive().prod); }, 8000);
    if (!ok) return false;
    var size = radios('.tee-option--size').find(function (i) { return /11\s*oz/i.test(i.value + ' ' + labelText(i)); });
    if (size) pick(size);
    await sleep(150);
    setTeeQuantity(1);
    // The mug doesn't come with the digital file (the canvas add switches it back to Yes).
    var no = teeDigitalRadio(false);
    if (no) {
      pick(no);
      await waitFor(function () { var b = no.closest('.tee-radio'); return b ? b.classList.contains('active') : no.checked; }, 3000);
      dbg('mug digital file -> No');
    }
    return true;
  }
  function goToCart() { location.href = '/cart'; }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.tee-btn--atc');
    if (!btn || btn.closest('.tee-dialog')) return;
    if (btn.__csPass) { btn.__csPass = false; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.__csBusy) return;          // ignore double-clicks while we prepare
    btn.__csBusy = true;
    try {
      showAtcMsg('');
      dbg('ATC clicked; cards=' + state.cards + ' mug=' + state.mug + ' size=' + state.size + ' frame=' + state.frame);
      var ok = await ensureSynced();
      if (!ok) {
        showAtcMsg('Something went wrong selecting your size and frame. Please re-select them and try again.');
        return;
      }
      setTeeQuantity(digital() ? 1 : 1 + state.extra);
      // Teeinblue's "Digital file" field is only a FLAG (it writes "Digital file: Yes" on the
      // portrait line for its Download block); it does not charge. The paid $9.99 Digital
      // Portrait File is always added by us, so the file is never given away free.
      if (teeDigitalField()) {
        syncDigitalAddon();
        await waitFor(digitalAddonMatches, 3000);
      }
      if (ADDON && !FREE_DIGITAL && state.addon && !digital()) {
        try { await addAddonOnce(); } catch (err) { /* never block the portrait add-to-cart */ }
      }
      // Canvas first: Teeinblue's form is already on it, so no switching back afterwards.
      var wantCards = state.cards && CARD_PACK && !digital(), wantMug = state.mug && MUG && !digital();
      if (wantCards || wantMug) showAtcMsg('Adding your portrait\u2026');
      var added = await teeAdd();
      dbg('canvas added=' + added);
      if (!added) { showAtcMsg('Something went wrong adding to cart. Please try again.'); return; }
      // Then each add-on through Teeinblue's own ATC (each gets its own customization / print file).
      var failed = [];
      if (wantCards) {
        showAtcMsg('Adding your matching Christmas cards\u2026');
        var cardsOk = (await selectCardsInTee()) && (await teeAdd());
        dbg('cards added=' + cardsOk);
        if (!cardsOk) failed.push('Christmas cards');
      }
      if (wantMug) {
        showAtcMsg('Adding your matching mug\u2026');
        var mugOk = (await selectMugInTee()) && (await teeAdd());
        dbg('mug added=' + mugOk);
        if (!mugOk) failed.push('mug');
      }
      if (failed.length) {
        showAtcMsg('Your portrait is in your cart, but we couldn\u2019t add the ' + failed.join(' and ') + '. Taking you to your cart\u2026');
        await sleep(2500);
      }
      goToCart();
    } finally {
      btn.__csBusy = false;
    }
  }, true);

  // ---- Visible "Custom Portrait: Created ✓" line property ------------------------------
  // Teeinblue builds its own add-to-cart request, and its properties are all hidden
  // (underscore-prefixed), so checkout shows nothing personal. Add one VISIBLE property to
  // any add-to-cart that carries a Teeinblue customization; Shopify then shows it in cart,
  // checkout, thank-you page, order emails and packing slips. Nothing else is modified.
  var ADD_PORTRAIT_PROP = false;  // Brian 2026-09-25: removed from cart/checkout
  var PORTRAIT_PROP = 'Custom Portrait';
  var PORTRAIT_VALUE = 'Created ✓';
  function tagItem(it) {
    var pr = it && it.properties;
    if (!ADD_PORTRAIT_PROP) return;
    if (pr && (pr._customization_id || pr.customization_id) && !pr[PORTRAIT_PROP]) pr[PORTRAIT_PROP] = PORTRAIT_VALUE;
  }
  function tagBody(body) {
    if (!ADD_PORTRAIT_PROP) return body;
    try {
      if (typeof body === 'string' && body.charAt(0) === '{') {
        var o = JSON.parse(body);
        (o.items || [o]).forEach(tagItem);
        return JSON.stringify(o);
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var hasCid = false;
        body.forEach(function (v, k) { if (/properties\]?\[_?customization_id\]/.test(k)) hasCid = true; });
        if (hasCid && !body.has('properties[' + PORTRAIT_PROP + ']')) body.append('properties[' + PORTRAIT_PROP + ']', PORTRAIT_VALUE);
        return body;
      }
      if (typeof body === 'string' && /_customization_id/.test(decodeURIComponent(body)) && body.indexOf(encodeURIComponent(PORTRAIT_PROP)) === -1) {
        return body + '&' + encodeURIComponent('properties[' + PORTRAIT_PROP + ']') + '=' + encodeURIComponent(PORTRAIT_VALUE);
      }
    } catch (err) { /* never break add-to-cart */ }
    return body;
  }
  function isCartAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }
  // Matching cards: when the canvas add carries a Teeinblue customization and the box is ticked,
  // add the 10-pack card variant first with the same customization (Teeinblue renders the card
  // from the same artwork). Canvas-specific Teeinblue fields (_tib_*) are not copied.
  var cardsAddedFor = null;
  function bodyProps(body) {
    var props = {};
    try {
      if (typeof body === 'string' && body.charAt(0) === '{') {
        var o = JSON.parse(body); var it = (o.items && o.items[0]) || o; return it.properties || {};
      }
      var add = function (k, v) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props[m[1]] = v; };
      if (typeof FormData !== 'undefined' && body instanceof FormData) body.forEach(function (v, k) { add(k, v); });
      else if (typeof body === 'string') new URLSearchParams(body).forEach(function (v, k) { add(k, v); });
    } catch (e) { /* ignore */ }
    return props;
  }
  // RETIRED 2026-10-06: a copied customization prints the CANVAS file on the cards (Teeinblue
  // builds files per customization). Cards are now added through Teeinblue's own ATC below.
  function addCardsFor(body) {
    if (true) return Promise.resolve();
    var props = bodyProps(body), cid = props._customization_id;
    if (!cid || cidAdded(cid)) return Promise.resolve();
    cardsAddedFor = cid;
    var p = {};
    // _customization_image dropped so checkout doesn't label the card line "Your custom portrait".
    Object.keys(props).forEach(function (k) { if (!/^_tib_/.test(k) && k !== '_customization_image') p[k] = props[k]; });
    p['Matching cards for'] = sizeLabel(state.size) + ' canvas';
    var f = window.__nativeFetch || _fetch;
    return f.call(window, '/cart/add.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: CARD_PACK.id, quantity: 1, properties: p }] }) }).catch(function () {});
  }
  function cidAdded(cid) { return cardsAddedFor === cid; }
  // Route 1: a hidden field in the product form(s) Teeinblue submits through (immune to
  // other apps re-wrapping fetch, e.g. One Click Upsell).
  function addHiddenField() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (f) {
      if (f.querySelector('input[name="properties[' + PORTRAIT_PROP + ']"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[' + PORTRAIT_PROP + ']'; i.value = PORTRAIT_VALUE;
      f.appendChild(i);
    });
    return forms.length > 0;
  }
  if (ADD_PORTRAIT_PROP) waitFor(addHiddenField, 20000);
  // Route 2: tag JSON / form-encoded add-to-cart requests carrying a Teeinblue customization.
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (isCartAdd(url) && init && init.body) {
          init = Object.assign({}, init, { body: tagBody(init.body) });
          var self = this, args = [input, init];
          return addCardsFor(init.body).then(function () { return _fetch.apply(self, args); })
            .then(function (r) { if (r && r.ok) noteCartAdd(); return r; });
        }
      } catch (err) { /* ignore */ }
      return _fetch.call(this, input, init);
    };
  }
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__csAdd = isCartAdd(url); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (!xhr.__csAdd) return _send.call(xhr, body);
    var b = tagBody(body);
    xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) noteCartAdd(); });
    addCardsFor(b).then(function () { _send.call(xhr, b); });
  };

  // ---- Events --------------------------------------------------------------------
  root.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('[data-cs-size]');
    var frameBtn = e.target.closest('[data-cs-frame]');
    var extraBtn = e.target.closest('[data-cs-extra]');
    var tab = e.target.closest('[data-cs-go]');
    if (sizeBtn && !sizeBtn.disabled) { state.size = sizeBtn.getAttribute('data-cs-size'); render(); syncTeeinblue(); }
    else if (frameBtn && !frameBtn.disabled) { state.frame = frameBtn.getAttribute('data-cs-frame'); render(); syncTeeinblue(); showFrameMedia(state.frame); }
    else if (extraBtn) { state.extra = +extraBtn.getAttribute('data-cs-extra'); render(); setTeeQuantity(1 + state.extra); }
    else if (tab && !tab.disabled) { var n = +tab.getAttribute('data-cs-go'); if (n <= state.step || n === state.step + 1) go(n); }
    else if (e.target.closest('[data-cs-next]')) go(state.step + 1);
    else if (e.target.closest('[data-cs-back]')) go(state.step - 1);
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-cs-addon]')) { state.addon = e.target.checked; render(); syncDigitalAddon(); }
    if (e.target.matches('[data-cs-cards]')) { state.cards = e.target.checked; render(); }
    if (e.target.matches('[data-cs-mug]')) { state.mug = e.target.checked; render(); }
  });

  async function go(n) {
    if (state.step === 1 && n > 1 && !formReady()) {
      if (continueMsg) continueMsg.hidden = false;
      return;
    }
    var dir = n > state.step ? 1 : -1;
    n = Math.max(1, Math.min(STEPS, n));
    if (n === 3 && digital()) n = n + dir;  // digital-only has no frame
    state.step = Math.max(1, Math.min(STEPS, n));
    render();
    if (state.step === STEPS) {
      if (syncing) await syncing;
      setTeeQuantity(1 + state.extra);
    }
    var top = root.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  // Teeinblue shows the campaign's description in its own box; show the Shopify description there instead
  // (re-applied if Teeinblue re-renders the box).
  (async function () {
    if (!data.description) return;
    var marker = 'data-cs-desc';
    function apply() {
      var box = document.querySelector('.tee-description__content');
      if (!box || box.querySelector('[' + marker + ']')) return !!box;
      box.innerHTML = '<div ' + marker + '>' + data.description + '</div>';
      box.style.height = 'auto';
      return true;
    }
    await waitFor(apply, 20000);
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  })();

  // Preview/QA hook: ?cs_step=3&cs_size=s2&cs_frame=black&cs_extra=2&cs_addon=1 opens the stepper pre-set.
  (function () {
    var q = new URLSearchParams(location.search);
    if (q.get('cs_size')) state.size = q.get('cs_size');
    if (q.get('cs_frame')) state.frame = q.get('cs_frame');
    if (q.get('cs_extra')) state.extra = Math.min(MAX_EXTRA, +q.get('cs_extra') || 0);
    if (q.get('cs_addon') === '1') state.addon = true;
    if (q.get('cs_step')) state.step = Math.max(1, Math.min(STEPS, +q.get('cs_step') || 1));
  })();
  // QA: ?cs_click_frame=dark-wood clicks that frame card 8s after load, like a shopper would.
  (function () {
    var f = new URLSearchParams(location.search).get('cs_click_frame');
    if (!f) return;
    setTimeout(function () { var b = root.querySelector('[data-cs-frame="' + f + '"]'); if (b) b.click(); }, 8000);
  })();

  render();
  syncTeeinblue();
  waitFor(mountContinue, 20000);
  waitFor(syncDigitalAddon, 20000);
  waitFor(mountLiveFrames, 25000);
  waitFor(mountLiveExtras, 25000);
  setInterval(function () { mountLiveFrames(); mountLiveExtras(); }, 1500);  // follow Teeinblue re-renders
  // Teeinblue can finish initializing after our first sync and reset its selection; re-assert once it settles.
  // ---- Friendlier upload errors ------------------------------------------------------
  // Teeinblue shows raw errors like "Cannot upload. Contact us for more information.:
  // UPLOAD_UNKNOWN_ERROR". Swap any of those for plain-English help.
  var UPLOAD_MSG = 'Sorry, that photo didn\u2019t upload. Please try again, or choose a different photo \u2014 a clear JPG or PNG from your phone works best.';
  function friendlyUploadErrors(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      if (/Cannot upload|UPLOAD_[A-Z_]+/.test(n.nodeValue) && n.nodeValue !== UPLOAD_MSG) n.nodeValue = UPLOAD_MSG;
      else if (/^\s*Choose another image\s*$/.test(n.nodeValue)) n.nodeValue = 'Don\u2019t like it? Upload a different photo';
    }
  }
  waitFor(function () { return document.querySelector('.tee-customize-main-form'); }, 20000).then(function (form) {
    if (!form) return;
    friendlyUploadErrors(form);
    // QA: ?cs_test_uploaderr=1 injects Teeinblue's raw error to check the rewrite.
    if (/cs_test_uploaderr=1/.test(location.search)) setTimeout(function () { var e = document.createElement('p'); e.className = 'cs-qa-uploaderr'; e.textContent = 'Cannot upload. Contact us for more information.: UPLOAD_UNKNOWN_ERROR'; form.appendChild(e); }, 2000);
    new MutationObserver(function () { friendlyUploadErrors(form); })
      .observe(form, { subtree: true, childList: true, characterData: true });
  });

  // ---- Gallery strip: live frame previews + Brian's own product images ---------------
  // Teeinblue's gallery only holds its campaign mockups. When the product has extra images
  // (lifestyle / "why us" / how-it-works shots uploaded in Shopify), we hide Teeinblue's
  // thumbnail row and draw one strip: its mockup thumbs first (clicking one clicks the hidden
  // Teeinblue thumb), then the extra images, which open over the live preview.
  // Disabled 2026-10-02: Brian chose the theme's native image gallery. Kept for easy re-enable.
  var EXTRA = [];
  var stripEl = null, overlayEl = null;
  function hideOverlay() {
    if (overlayEl) overlayEl.hidden = true;
    if (stripEl) stripEl.querySelectorAll('.cs-strip__extra').forEach(function (b) { b.classList.remove('is-active'); });
    syncStripActive();
  }
  function showExtra(idx) {
    var g = document.getElementById('tee-gallery');
    var stage = g && g.querySelector('.tee-gallery__stage');
    if (!stage) return;
    var host = g.parentNode;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    if (!overlayEl) {
      overlayEl = document.createElement('div');
      overlayEl.className = 'cs-gallery-overlay';
      overlayEl.innerHTML = '<img alt="">';
      host.appendChild(overlayEl);
    }
    var r = stage.getBoundingClientRect(), hr = host.getBoundingClientRect();
    overlayEl.style.top = (r.top - hr.top) + 'px';
    overlayEl.style.left = (r.left - hr.left) + 'px';
    overlayEl.style.width = r.width + 'px';
    overlayEl.style.height = r.height + 'px';
    var img = overlayEl.querySelector('img');
    img.src = EXTRA[idx].src; img.alt = EXTRA[idx].alt || '';
    overlayEl.hidden = false;
    stripEl.querySelectorAll('.cs-strip__btn').forEach(function (b) { b.classList.remove('is-active'); });
    var btn = stripEl.querySelector('.cs-strip__extra[data-idx="' + idx + '"]');
    if (btn) btn.classList.add('is-active');
  }
  function syncStripActive() {
    if (!stripEl || (overlayEl && !overlayEl.hidden)) return;
    var tee = document.querySelectorAll('#tee-gallery .tee-mockup-thumbnail');
    stripEl.querySelectorAll('.cs-strip__tee').forEach(function (b, i) {
      var box = tee[i] && tee[i].closest('.tee-thumbnail');
      b.classList.toggle('is-active', tee.length ? !!(box && box.classList.contains('tee-thumbnail--active')) : true);
    });
  }
  function renderStrip() {
    var g = document.getElementById('tee-gallery');
    if (!g || !EXTRA.length) return;
    var tee = Array.prototype.slice.call(g.querySelectorAll('.tee-mockup-thumbnail'));
    // A product with one mockup (e.g. unframed canvas) has no Teeinblue thumbnails, so give the
    // live preview its own thumb — otherwise there's no way back from an extra image.
    var srcs = tee.length ? tee.map(function (t) { return t.getAttribute('src'); }) : [data.liveThumb || ''];
    var sig = srcs.join('|');
    if (!stripEl) {
      stripEl = document.createElement('div');
      stripEl.className = 'cs-strip';
      g.parentNode.insertBefore(stripEl, g.nextSibling);
      document.body.classList.add('cs-has-strip');
      // the gallery just got narrower (desktop column) — let Teeinblue re-measure its slider
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 50);
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 600);
    }
    if (stripEl.getAttribute('data-sig') !== sig) {
      stripEl.setAttribute('data-sig', sig);
      stripEl.innerHTML = srcs.map(function (src, i) {
        return '<button type="button" class="cs-strip__btn cs-strip__tee" data-idx="' + i + '" aria-label="Live preview"><img src="' + src + '" alt=""></button>';
      }).join('') + EXTRA.map(function (e, i) {
        return '<button type="button" class="cs-strip__btn cs-strip__extra" data-idx="' + i + '"><img src="' + e.thumb + '" alt="' + String(e.alt || '').replace(/"/g, '&quot;') + '" loading="lazy"></button>';
      }).join('');
    }
    var st = g.querySelector('.tee-gallery__stage');
    if (st && window.matchMedia('(min-width:960px)').matches) stripEl.style.maxHeight = Math.round(st.getBoundingClientRect().height) + 'px';
    syncStripActive();
  }
  if (EXTRA.length) {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.cs-strip__btn');
      if (!b) return;
      var i = +b.getAttribute('data-idx');
      if (b.classList.contains('cs-strip__extra')) { showExtra(i); return; }
      hideOverlay();
      var tee = document.querySelectorAll('#tee-gallery .tee-mockup-thumbnail');
      if (tee[i]) tee[i].click();
      setTimeout(syncStripActive, 150);
    });
    waitFor(function () { return document.querySelector('#tee-gallery .tee-mockup-thumbnail'); }, 20000).then(function () {
      renderStrip();
      new MutationObserver(function () { renderStrip(); }).observe(document.getElementById('tee-gallery'), { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'src'] });
      // QA: ?cs_show_extra=0 opens that extra image a few seconds after load.
      var qx = new URLSearchParams(location.search).get('cs_show_extra');
      if (qx !== null) setTimeout(function () { showExtra(+qx); }, 3000);
    });
  }

  waitFor(function () { return document.querySelector('.tee-available-products'); }, 20000)
    .then(function () { return sleep(1500); })
    .then(ensureSynced)
    .then(function (ok) { dbg('load ensureSynced=' + ok); });
})();
